module.exports = __webpack_public_path__ + "static/media/logo139.8904617c.png";